import { render } from "./ReportingManagerList.vue?vue&type=template&id=5bfbb6ff"
import script from "./ReportingManagerList.vue?vue&type=script&lang=js"
export * from "./ReportingManagerList.vue?vue&type=script&lang=js"

import "./ReportingManagerList.vue?vue&type=style&index=0&id=5bfbb6ff&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__